import { Spinner } from "@next-platform/client-common-spicy-ui";
import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import useAuth from "@/services/useAuth";

import { GroupChatFormProvider } from "./GroupChatFormContext";

export default function GroupChatLayout() {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  let pageContent: ReactNode;
  if (isAuthLoading) {
    pageContent = <Spinner />;
  } else if (!isAuthenticated) {
    pageContent = <AnonymousMarketing datakey="group" />;
  } else {
    pageContent = (
      <GroupChatFormProvider>
        <Outlet />
      </GroupChatFormProvider>
    );
  }

  return (
    <>
      <PageStaticMetaTags pageId="createGroup" data-testid="GroupChatLayout-PageStaticMetaTags" />
      {pageContent}
    </>
  );
}
